/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Page_TitleInputs */

const de_home_page_title = /** @type {(inputs: Home_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Startseite`)
};

/** @type {(inputs: Home_Page_TitleInputs) => LocalizedString} */
const en_home_page_title = de_home_page_title;

/**

* @param {Home_Page_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const home_page_title = /** @type {((inputs?: Home_Page_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Page_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_home_page_title(inputs)
	return en_home_page_title(inputs)
});